import { jsx as _jsx } from "preact/jsx-runtime";
import IconCloseTiny from '@fandom-frontend/react-common/dist/icons/IconCloseTiny';
import styles from './styles/ModalCloseButton.module.scss';
const ModalCloseButton = ({ id, fill, right, top, role, ariaLabel, style, onClick }) => {
    const combinedStyles = Object.assign({ fill, right, top }, style);
    return (_jsx(IconCloseTiny, { id: id, class: styles.closeButton, style: combinedStyles, "aria-label": ariaLabel, role: role, onClick: onClick }, void 0));
};
export default ModalCloseButton;
